import router from "@/router";

const install = Vue => {
  // Object.defineProperty(Vue.prototype, "$screen", {
  //   get() {
  //     let title = null;
  //     if (router.app.$route.params && router.app.$route.params.title) {
  //       title = router.app.$route.params.title;
  //     }
  //     return {
  //       title: title
  //     };
  //   }
  // });

  Vue.prototype.$screen = {
    title(defaultTitle) {
      return router.app.$route.params && router.app.$route.params.title
        ? router.app.$route.params.title
        : defaultTitle;
    }
  };

  Vue.prototype.$linkTo = (name, title) => {
    return {
      name: name,
      params: { title: title }
    };
  };
};
export default {
  install
};
